export const LIVE_TAB_CATCH_UP_AFTER_MS = 20_000
export const LIVE_TAB_REFRESH_GRACE_MS = 12_000

export function shouldCatchUpAfterTabHidden(hiddenAt: number | null, visibleAt: number): boolean {
  return hiddenAt !== null && visibleAt - hiddenAt >= LIVE_TAB_CATCH_UP_AFTER_MS
}
